module.exports = __webpack_public_path__ + "img/imagen5.b4cbf2d6.png";